/* Datumseingabe als Text "TT.MM.JJJJ" — reine Funktionen, kein DOM, kein Date-Objekt.
 *
 * Das native <input type="date"> zeigt das Datum nach der Sprache des Browsers (in den USA MM/TT/JJ) und lässt
 * sich nicht erzwingen. DateField.vue setzt deshalb ein Textfeld ein; hier steht die Umrechnung.
 * Gespeichert wird weiter ISO ("JJJJ-MM-TT"). Die Umrechnung arbeitet nur mit Text und Zahlen, damit keine
 * Zeitzone einen Tag Abweichung erzeugen kann (new Date("2008-03-15") wäre UTC, die Anzeige Ortszeit).
 */

const DISPLAY = /^(\d{2})\.(\d{2})\.(\d{4})$/;
const ISO = /^(\d{4})-(\d{2})-(\d{2})$/;

/**
 * Eingabe maskieren: nur Ziffern, höchstens acht, Punkte nach Tag und Monat.
 * "15032008" → "15.03.2008", "1503" → "15.03", "15." → "15" (Punkt am Ende gehört dem Tippenden nicht).
 */
export function maskDateInput(raw) {
  const digits = String(raw ?? '').replace(/\D/g, '').slice(0, 8);
  if (digits.length <= 2) return digits;
  if (digits.length <= 4) return `${digits.slice(0, 2)}.${digits.slice(2)}`;
  return `${digits.slice(0, 2)}.${digits.slice(2, 4)}.${digits.slice(4)}`;
}

/** Anzahl Tage eines Monats (Schaltjahr nach gregorianischer Regel). */
export function daysInMonth(year, month) {
  if (month === 2) return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0 ? 29 : 28;
  return [4, 6, 9, 11].includes(month) ? 30 : 31;
}

/** Gibt es diesen Kalendertag wirklich? */
export function isRealDate(year, month, day) {
  return month >= 1 && month <= 12 && day >= 1 && day <= daysInMonth(year, month);
}

/**
 * "TT.MM.JJJJ" → "JJJJ-MM-TT". Rein mechanisch: Ist die Eingabe vollständig, wird umgestellt, auch wenn der Tag
 * nicht existiert ("31.02.2008" → "2008-02-31") — die Prüfung (validateBirthDate) meldet das dann als ungültig.
 * Unvollständige Eingabe → ''.
 */
export function displayToIso(text) {
  const m = DISPLAY.exec(String(text ?? '').trim());
  return m ? `${m[3]}-${m[2]}-${m[1]}` : '';
}

/** "JJJJ-MM-TT" → "TT.MM.JJJJ"; alles andere → ''. */
export function isoToDisplay(iso) {
  const m = ISO.exec(String(iso ?? '').trim());
  return m ? `${m[3]}.${m[2]}.${m[1]}` : '';
}
